// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureWrapper_root__Ib1jB","wrapper":"FeatureWrapper_wrapper__uPkBi","sizeWrapper":"FeatureWrapper_sizeWrapper__G1Fyp"};